import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const Context = createContext(undefined);
const { Provider } = Context;
export const useLocalization = () => {
    const result = useContext(Context);
    if (result === undefined) {
        throw new Error('useLocalization must be used within a LocalizationProvider');
    }
    return result;
};
/**
 * This component should be rendered at the top of upload-components application tree. It providees all pre-localized
 * strings to various child components. The host application that renders the UploadComponents is responsible for
 * provided the localized strings. This component does not do the localization itself.
 *
 * @param {LocalizationProviderProps} props
 * @returns ReactNode
 */
export const LocalizationProvider = ({ children, localizedValues }) => {
    return _jsx(Provider, Object.assign({ value: localizedValues }, { children: children }));
};
//# sourceMappingURL=LocalizationProvider.js.map